module.exports = __webpack_public_path__ + "img/Group1.7cfb1535.svg";